export default __webpack_public_path__ + "static/media/scale-subscription-paid.fce4050c.svg";